import React, { useContext } from 'react'
import { LocaleContext } from '../../contexts/locale'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/table.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/statistic.css'
import styles from './styles.module.scss'
import '../questions/styles.scss'
import { QuestionDefinition } from 'types/QuestionDefinition'
import { QuestionState } from 'components/questions/reducer'
import { QuestionStatistics } from 'types/QuestionStatistics'
import IntlMessageFormat from 'intl-messageformat'
import { ArticleList } from 'components/articleList'

interface StatisticsProps {
  selectedAnswers: QuestionState
  statistics: QuestionStatistics
  showStatistics: boolean
}

export const Statistics = ({
  selectedAnswers,
  statistics,
  showStatistics
}: StatisticsProps) => {
  const locale = useContext(LocaleContext)
  const questions = require('locales/questions.' + locale + '.yml')
  const guessMessages = require('components/questions/locales/' +
    locale +
    '.yml')
  const messages = require('./locales/' + locale + '.yml')
  const participantsMessage = new IntlMessageFormat(
    messages.participants,
    locale + '-CH'
  )
  const percentFormat = new Intl.NumberFormat(locale + '-CH', {
    style: 'percent'
  })

  if (!showStatistics) return null

  return (
    <div
      className={`${
        styles.statistics
      } ui vertical infographic inverted basic segment`}
    >
      <div className='ui text container'>
        <h3 className={`ui inverted small header ${styles.distressed}`}>
          {messages.title}
        </h3>
        <p
          dangerouslySetInnerHTML={{
            __html: participantsMessage.format({
              participants: statistics.participants
            })
          }}
        />
      </div>

      <div className='ui vertical segment questions'>
        <div className='ui container'>
          <div className='ui inverted vertically divided grid'>
            {questions.map((q: QuestionDefinition) => {
              const sizes =
                q.id === 'dragons' ? '(min-width: 600px) 100vw, 140vw' : '300px'
              const image = require('images/questions/' +
                q.id +
                '.png?sizes=300w+600w+800w+1200w+1600w')
              const optionsInCategory = statistics.questions[q.id]
              const allOptions: [
                string,
                string,
                number,
                number
              ][] = Object.keys(q.options)
                .map(key => [
                  key,
                  q.options[key],
                  optionsInCategory[key] || 0,
                  (optionsInCategory[key] || 0) / statistics.participants
                ])
                .sort((a, b) => b[3] - a[3])

              return (
                <React.Fragment key={q.id}>
                  <div
                    className='stackable row middle aligned two column question'
                    id={q.id}
                  >
                    <div className='column image'>
                      <img
                        src={image.sources['600w']}
                        srcSet={image.srcSet}
                        sizes={sizes}
                        alt=''
                        className='ui centered medium image'
                      />
                    </div>
                    <div className='column content'>
                      <h4 className='ui inverted header'>{q.question}</h4>
                      {selectedAnswers[q.id] && (
                        <table
                          className={`ui inverted unstackable small compact table ${
                            styles.transparentTable
                          }`}
                        >
                          <tbody>
                            {allOptions.map(
                              ([key, translation, counts, relative]) => (
                                <tr
                                  key={key}
                                  className={
                                    selectedAnswers[q.id].has(key)
                                      ? styles.active
                                      : ''
                                  }
                                >
                                  <td>
                                    {q.correct.includes(key) && (
                                      <i className='inverted check icon' />
                                    )}
                                  </td>
                                  <td>{translation}</td>
                                  <td className='collapsing'>
                                    {percentFormat.format(relative)}
                                  </td>
                                  <td className='eight wide'>
                                    <div
                                      className={styles['horizontal-bar']}
                                      style={{
                                        width: relative * 100 + '%'
                                      }}
                                    />
                                  </td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>

                  {q.id === 'throne' && (
                    <aside
                      key='articleList'
                      className='ui two column centered stackable row question'
                      id='aside'
                    >
                      <div className='column'>
                        <ArticleList />
                      </div>
                    </aside>
                  )}
                </React.Fragment>
              )
            })}

            <div className='stackable row middle aligned two column question'>
              <div className='column'>
                <h4 className='ui inverted header'>
                  {guessMessages.guess.question}
                </h4>
                <div className='ui one statistics'>
                  <div className='ui inverted statistic'>
                    <div className='value'>1</div>
                    <div className='label'>Night King</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
